<template>
    <v-card>
        <v-card-title class="font-italic grey--text darken-3 text-uppercase">{{ $t('payment') }}</v-card-title>
        <v-card-text class="pb-0">
            <v-row>
                <v-col cols="12" md="4">
                    <v-text-field
                        :value="paymentInfo.paymentWay"
                        :label="$t('paymentWay')"
                        disabled
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                    <v-text-field
                        v-if="paymentInfo.companyName"
                        :value="paymentInfo.companyName"
                        :label="$t('companyName')"
                        disabled
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                    <v-text-field
                        v-if="paymentInfo.edprou"
                        :value="paymentInfo.edprou"
                        :label="$t('edprou')"
                        disabled
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import {MixinOrderInfo} from "../../../mixins";

export default {
    name: "PaymentInfo",
    mixins: [MixinOrderInfo],
    computed: {

        paymentInfo() {
            const { paymentWay, companyName, edprou } = this.order.payment;
            return { paymentWay, companyName, edprou };
        },
    },
}
</script>

<style scoped>

</style>
